import React, { useState } from 'react'
import { useWordPressStatistics } from '../uses/useWordpressStatistics'
import { useStatisticCategory } from '../uses/useStatisticCategory'
import StatisticFullPage from './StatisticFullPage'

// const StatisticCategory = ({ id }) => {
//   const category = useStatisticCategory(id)
//   return (
//     <div className="events-category">
//       {category.node.name}
//       <i className={`icon-category icon-${category.node.slug}`} />
//     </div>
//   )
// }

const StatisticGrid = ({ page }) => {
  const statistics = useWordPressStatistics()

  const [statistic, setStatistic] = useState(null)
  const [statisticIndex, setStatisticIndex] = useState(null)

  if (typeof window !== 'undefined') {
    const currentIndex = statistics.findIndex(
      statistic => statistic.node.slug == window.location.hash.replace('#', '')
    )

    if (currentIndex !== statisticIndex) {
      setStatistic(currentIndex !== -1 ? statistics[currentIndex] : null)
      setStatisticIndex(currentIndex)
    }
  }

  const setSelectedStatistic = index => {
    if (index === null && typeof window !== 'undefined') {
      setStatistic(null)
      return history.pushState('', document.title, window.location.pathname)
    }

    if (index > statistics.length - 1) {
      index = 0
    }

    if (index < 0) {
      index = statistics.length - 1
    }

    window.location.hash = statistics[index].node.slug
    setStatisticIndex(index)
    setStatistic(statistics[index])
  }

  let prevDate = null
  return (
    <React.Fragment>
      <section className="events-wrapper">
        {statistics.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <article className="events-item statistics-item">
                <a
                  onClick={e => {
                    e.preventDefault()
                    setSelectedStatistic(index)
                  }}
                  href="#"
                  className="inner"
                >
                  <div className="inner-wrapper">
                    {/* <h2
                      className="events-title"
                      dangerouslySetInnerHTML={{ __html: item.node.title }}
                    /> */}
                    <div className="events-headlines">
                      <p> {item.node.acf.headlines}</p>
                    </div>
                    <div className="events-category">
                      <span>Plus d'information</span>
                    </div>
                  </div>
                </a>
              </article>
            </React.Fragment>
          )
        })}
      </section>
      <StatisticFullPage
        statistic={statistic}
        statisticIndex={statisticIndex}
        setSelectedStatistic={setSelectedStatistic}
      />
    </React.Fragment>
  )
}

export default StatisticGrid
